import { FC } from 'react';
import { TypeMegaMenuComponentWithoutUnresolvableLinksResponse } from '@shared/features/contentful/_generated';
import ContentfulIcon from '@shared/components/Icon/ContentfulIcon';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import { useSettingsContext } from '@shared/contexts/SettingsContext';

interface IFooterFollowUsProps {
    socialLinks?: TypeMegaMenuComponentWithoutUnresolvableLinksResponse['fields']['socialLinks'];
    contentfulEntryId: string;
}

const FooterFollowUs: FC<IFooterFollowUsProps> = ({ socialLinks, contentfulEntryId }) => {
    const inspectorProps = useContentfulInspectorMode({ entryId: contentfulEntryId });

    const { getLabel } = useSettingsContext();
    const labelFollowUsOn = getLabel(['footer', 'followUsOn']);

    return (
        <div {...inspectorProps({ fieldId: 'socialLinks' })}>
            <p
                className="block text-sm font-medium text-colourContainerTertiary mb-6"
                {...inspectorProps({ fieldId: 'settings' })}
            >
                {labelFollowUsOn}
            </p>
            <div className="flex gap-[29px] md:gap-0 justify-start md:justify-between items-center ">
                {socialLinks?.map(
                    (socialLink) =>
                        socialLink && (
                            <ContentfulIcon
                                key={socialLink.sys.id}
                                data={socialLink}
                                width={24}
                                height={24}
                                classes={{
                                    icon: 'fill-colourContainerTertiary',
                                    iconHover: 'group-hover:fill-foregroundGold',
                                    link: 'group accessibility-focus',
                                }}
                            />
                        ),
                )}
            </div>
        </div>
    );
};

export default FooterFollowUs;
